import { fetcher } from '../../utils/fetchers/fetcher';
import { resolveApiPath } from '../../utils/resolveApiPath';
import { Body } from '../../types/types';
import { Layout } from '../../../types/types';

export type PutLayoutResponse = {
  success: boolean;
  id: number;
};

// PUT whole layout content. Path is resolved from the definition's apiMethods.put.
export const putLayout = (
  path: string,
  layout: Layout,
  token: string | null,
  forceHeader?: string
): Promise<PutLayoutResponse> =>
  fetcher<PutLayoutResponse>(
    resolveApiPath(path),
    'PUT',
    token,
    forceHeader,
    undefined,
    layout as unknown as Body
  );
